/** Date arithmetic helpers that work in UTC for stable day-index math.
 *
 * Used by the Logic tab's mini-Gantt and any other view that needs to compute
 * pixel positions from calendar dates without DST/timezone surprises.
 */

/** Parse a "YYYY-MM-DD" or "YYYY-MM-DD HH:MM" prefix as a UTC midnight Date. */
export function parseISODay(s: string | null | undefined): Date | null {
  if (!s) return null;
  const ymd = s.slice(0, 10);
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(Date.UTC(y, m - 1, d));
}

export function addDays(d: Date, n: number): Date {
  return new Date(d.getTime() + n * 24 * 60 * 60 * 1000);
}

/** Whole days from `axisStart` to `d` (rounded). */
export function diffDays(d: Date, axisStart: Date): number {
  return Math.round((d.getTime() - axisStart.getTime()) / (1000 * 60 * 60 * 24));
}
